export default "/images/interacted.svg?e22e56ba48be6994136f5901f6b5958f";